import debounce from '../utils/debounce';

export default function whenElementIsInWindow(element, callback) {
    const elementsShown = window.whenElementIsInWindowElements || [];
    function run() {
        const currentScrollPos = window.scrollY + window.innerHeight;
        const elementHasBeenShown = elementsShown.find(_e => _e === element);
        const elementY = (element && element.getBoundingClientRect().y) || 0;

        if (!elementHasBeenShown && elementY > 0 && elementY <= currentScrollPos) {
            callback(element);
            elementsShown.push(element);
        }

        window.whenElementIsInWindowElements = elementsShown;
    }
    debounce(run)();
    document.addEventListener('scroll', debounce(run));
}
